module.exports = __webpack_public_path__ + "static/media/icon_menu_hbl.13476e08.svg";